import { LinearProgress } from "@evergis/ui";
import React, { FC, useEffect, useState } from "react";
import { getImageSrc } from "./getImageSrc";
import { GridImagePreview, ImagePreviewContainer, ImagePreviewLoaderContainer } from "./styled";

export interface FileImagePreviewProps {
  link: string;
  isExternal: boolean;
  size?: string;
  height?: number;
  width?: number;
  borderRadius?: string;
}

export const FileImagePreview: FC<FileImagePreviewProps> = ({
  link,
  isExternal,
  size,
  height,
  width,
  borderRadius,
}) => {
  const [imageSrc, setImageSrc] = useState<string>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setImageSrc(await getImageSrc(isExternal, link));
    })();
  }, [isExternal, link]);

  return (
    <ImagePreviewContainer height={height} width={width} size={size}>
      {loading && (
        <ImagePreviewLoaderContainer>
          <LinearProgress />
        </ImagePreviewLoaderContainer>
      )}
      <GridImagePreview
        isLoading={loading}
        borderRadius={borderRadius}
        height={height}
        width={width}
        onLoad={() => setLoading(false)}
        size={size}
        src={imageSrc}
      />
    </ImagePreviewContainer>
  );
};
